import { ButtonHTMLAttributes } from 'react';
import './button.scss';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Which class has the button
   */
  variant: 'black' | 'white' | 'add' | 'yellow';
  /**
   *  Add the text to be displayed on the button
   */
  label: string;
  /**
   * Optional click handler
   */
  onClick?: () => void;
  /**
   * Set if the input is disabled
   */
  disabled?: boolean;
  fullWidth?: boolean;
}

export const Button = ({
  variant = 'black',
  label = 'mi botón',
  disabled = false,
  onClick,
  ...props
}: Props) => {
  const handleButtonClick = () => {
    onClick?.();
  };

  return (
    <button
      className={`button button__${variant} ${disabled ? 'button__disabled' : ''}`}
      onClick={handleButtonClick}
      {...(disabled ? { disabled: true } : {})}
      {...props}
    >
      {label.toUpperCase()}
    </button>
  );
};

export default Button